export function renderAdminShadowInputUtility(): string {
  return `
@utility shadow-input {
  --admin-shadow-input: rgba(0, 0, 0, 0.02) 0px 4px 8px -2px;
  --tw-shadow: var(--admin-shadow-input);
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow),
    var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}`
}
